import { useHaptics } from '@/hooks/use-haptics';
import { Button } from '@mantine/core';
import { ComponentProps } from 'react';
import styles from './styles.module.css';

type CompactButtonProps<C = 'button'> = ComponentProps<typeof Button<C>>;

export const CompactButton = (props: CompactButtonProps) => {
	const onClick = useHaptics(props);

	return (
		<Button
			variant="transparent"
			color="black"
			p="0"
			{...props}
			onClick={onClick}
			className={styles.button}
		/>
	);
};
